var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgD20PlanFree = function SvgD20PlanFree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.987%",
    y1: "14.506%",
    x2: "70.348%",
    y2: "86.601%",
    id: "d-20-plan-free_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8695FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CC5BE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d-20-plan-free_svg__a)",
    d: "M0 4.625v9.25L8 18.5l8-4.625v-9.25L8 0z",
    transform: "translate(2 1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeOpacity: 0.2,
    stroke: "#FFF",
    d: "M2.875 6.125v8.25L10 18.5l7.125-4.125v-8.25L10 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M9.224 14.082v-2.886h3.423v-1.46H9.224V8.024h3.848v-1.48h-5.53v7.538z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }))));
};
export default SvgD20PlanFree;